// Formato local isolado para permitir trocar a origem do layout por uma API no futuro.
export type TopologyPosition = { x: number; y: number }
export type TopologyPositions = Record<string, TopologyPosition>
export type TopologyLayoutScope = { userId: string; organizationId: string }

const storageKey = ({ userId, organizationId }: TopologyLayoutScope) =>
  `nebvla-ec-topology-layout:v1:${userId}:${organizationId}`

const validPosition = (value: unknown): value is TopologyPosition => {
  if (!value || typeof value !== 'object') return false
  const position = value as Partial<TopologyPosition>
  return Number.isFinite(position.x) && Number.isFinite(position.y)
}

export const readTopologyPositions = (scope: TopologyLayoutScope): TopologyPositions => {
  try {
    const raw = localStorage.getItem(storageKey(scope))
    if (!raw) return {}
    const parsed: unknown = JSON.parse(raw)
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return {}

    return Object.fromEntries(
      Object.entries(parsed).filter((entry): entry is [string, TopologyPosition] =>
        validPosition(entry[1]),
      ),
    )
  } catch {
    // Storage indisponível ou dado antigo/corrompido: usar as posições da API.
    return {}
  }
}

export const saveTopologyPosition = (
  scope: TopologyLayoutScope,
  nodeId: string,
  position: TopologyPosition,
): void => {
  if (!validPosition(position)) return
  try {
    const positions = readTopologyPositions(scope)
    localStorage.setItem(storageKey(scope), JSON.stringify({ ...positions, [nodeId]: position }))
  } catch {
    // O diagrama continua utilizável quando o navegador bloqueia o storage.
  }
}

export const clearTopologyPositions = (scope: TopologyLayoutScope): void => {
  try {
    localStorage.removeItem(storageKey(scope))
  } catch {
    // O diagrama continua utilizável quando o navegador bloqueia o storage.
  }
}

export const positionTopologyNodes = <T extends { id: string; position: TopologyPosition }>(
  nodes: T[],
  positions: TopologyPositions,
): T[] => nodes.map((node) => ({ ...node, position: positions[node.id] ?? node.position }))
